module.exports = __webpack_public_path__ + "static/img/编组 5备份 5.0e4411e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hz/编组 5备份 5.png
// module id = QO44
// module chunks = 1